export enum PayBalanceType {
  Balance = "BALANCE",
  BalanceWithEstimate = "BALANCE_ESTIMATE",
}
